import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { signIn } from '../../redux/slices/authSlice';

const LoginPage = () => {
  const dispatch = useAppDispatch();
  const hasCalledSignIn = useRef(false);

  useEffect(() => {
    // Prevent duplicate calls from React.StrictMode in development
    if (hasCalledSignIn.current) {
      return;
    }
    
    const configureIdamSignIn = async () => {
      try {
        hasCalledSignIn.current = true;
        await dispatch(signIn()).unwrap();
      } catch (error) {
        console.error('❌ Sign-in failed:', error);
        hasCalledSignIn.current = false; // Reset on error so it can retry
      }
    };
    
    configureIdamSignIn();
  }, [dispatch])

  return (
      <div>
        <h6>Redirecting</h6>
      </div>
  );
};

export default LoginPage;